import { isBlobURL } from "../../dom/index.js";
import { getBlockProps } from "../blocks-parser/index.js";

const videoSingleSchema = {
  video: {
    attributes: ["autplay", "muted", "loop", "src", "playsinline"],
    classes: ["alignleft", "aligncenter", "alignright", "alignnone"],
  },
};

const props = {
  align: {
    type: "string",
  },
  src: {
    type: "string",
    source: "attribute",
    selector: "video",
    attribute: "src",
  },
  srcMode: {
    type: "string",
    default: "link",
  },
  altText: {
    type: "string",
    source: "attribute",
    selector: "video",
    attribute: "alt",
    default: "",
  },
  caption: {
    type: "string",
    source: "html",
    selector: "figcaption",
  },
  titleText: {
    type: "string",
    source: "attribute",
    selector: "video",
    attribute: "title",
  },
  imageLink: {
    type: "string",
    source: "attribute",
    selector: "figure > a",
    attribute: "href",
  },
  width: {
    type: "number",
  },
  height: {
    type: "number",
  },
};

const videoSchema = {
  blockSlug: "grigora/video",
  isMatch: (node) =>
    node.nodeName === "FIGURE" && !!node.querySelector("video"),
  schema: ({ phrasingContentSchema }) => ({
    figure: {
      require: ["video"],
      children: {
        ...videoSingleSchema,
        a: {
          attributes: ["href", "rel", "target"],
          children: videoSingleSchema,
        },
        figcaption: {
          children: phrasingContentSchema,
        },
      },
    },
  }),
  transform: (node) => {
    var blockProps = getBlockProps("grigora/video", node.outerHTML, props);

    blockProps = {
      ...blockProps,
      srcMode: "link",
    };

    if (blockProps.src && isBlobURL(blockProps.src)) {
      blockProps = {
        ...blockProps,
        srcMode: "link",
        srcActionTrigger: "upload",
      };
    }
    return {
      blockSlug: "grigora/video",
      blockProps: blockProps,
    };
  },
};

export { videoSchema };
